import 'components/Public/style.css'

import React, { Component } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

import Editor from './Editor'
import { Error, NoteContainerLayout, HeaderLayout, NoteLayout } from './Layout'
import Header from 'components/Public/Header'
import PromotionalModal from 'components/Public/PromotionalModal'

class PublicNote extends Component {
  static propTypes = {
    note: PropTypes.object,
    organization: PropTypes.object,
    alreadyJoined: PropTypes.bool,
    alreadyUser: PropTypes.bool,
  }

  componentDidMount() {
    // Ensure Intercom doenst load
    if (window.Intercom) {
      window.Intercom('hide')
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.note !== newProps.note) {
      const container = document.querySelector('.public-note')
      if (container) {
        container.scrollTo(0, 0)
      }
    }
  }

  render() {
    const { note, organization, error, alreadyJoined, alreadyUser } = this.props

    if (error) {
      return (
        <NoteContainerLayout>
          <Error />
        </NoteContainerLayout>
      )
    }

    if (!note || !organization) {
      return false
    }

    const freePlan = organization.get('product') === 'free'
    const isEditable = Boolean(note.get('madePubliclyEditableAt'))
    const showPromotionalBanner = freePlan && !alreadyUser
    const noteTitle = note.get('title') || 'Untitled'

    return (
      <React.Fragment>
        <Helmet
          title={`${noteTitle} - Slite`}
          meta={[
            {
              name: 'viewport',
              content: 'width=device-width, user-scalable=no',
            },
            {
              name: 'og:site_name',
              content: 'Slite',
            },
            {
              name: 'og:title',
              content: noteTitle,
            },
            {
              name: 'og:type',
              content: 'article',
            },
          ]}
        />
        <HeaderLayout>
          <Header
            freePlan={freePlan}
            organizationName={organization.get('name')}
            organizationPhotoURL={organization.get('photoURL')}
            alreadyJoined={alreadyJoined}
          />
        </HeaderLayout>
        <NoteContainerLayout>
          <NoteLayout>
            <Editor
              noteId={note.get('id')}
              noteTitle={note.get('title')}
              noteDocType={note.get('docType')}
              isEditable={isEditable}
            />
          </NoteLayout>
        </NoteContainerLayout>
        {showPromotionalBanner && <PromotionalModal origin="note" />}
      </React.Fragment>
    )
  }
}

export default PublicNote
